// extracted by mini-css-extract-plugin
module.exports = {"HealthMonitorTable":"HealthMonitorTable_HealthMonitorTable__MIzwt"};